import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service =  {
    name: 'EnbridgePipeline',
    label: 'Enbridge',
    permissionId: 'pipeline',
    iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: true,
  data: [
  ],
  layers: [
    {
      name: 'EnbridgePipeline',
      label: 'Enbridge Pipeline',
      opacity: 'vector-opacity',
      datetimeId: 'PipelineGreen',
    }
    ],
  locations: [
    {
      name: 'Montral',
      label: 'Montreal',
      latitude: 45.3362,
      longitude: -73.5275, // 45.3362, -73.5275
      zoom: [13]
    }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/EnbridgePipeline.js